import { CALL_API } from '../../../redux-store/middleware';
import {
  DigilockerCallbackResponse,
  ESIGN_KYC_DOCUMENT,
  ESIGN_KYC_DOCUMENT_SUCCESS,
  GET_DIGILOCKER_CALLBACK,
  GET_DIGILOCKER_CALLBACK_SUCCESS,
  GET_KYC_DIGILOCKER_URL,
  GET_KYC_DIGILOCKER_URL_SUCCESS,
  GetDigilockerUrlResponse,
  REDIRECT_KYC_UPDATE_SUCCESS,
  UPDATE_DIGILOCKER_ADDRESS,
  UPDATE_DIGILOCKER_ADDRESS_SUCCESS,
} from '../types/digilocker';

export const getDigilockerUrl =
  (
    applicationId: string,
    token: string,
    digiLockerConsent: boolean,
    referenceId: string,
    origin: string
  ) =>
  async (dispatch: any): Promise<GetDigilockerUrlResponse> => {
    console.log(token, 'inside action');
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/digilocker/getDigiLockerUri`,
        method: 'GET',
        types: [GET_KYC_DIGILOCKER_URL_SUCCESS, GET_KYC_DIGILOCKER_URL],
        params: {
          applicationId,
          token,
          digiLockerConsent,
          referenceId,
          origin,
        },
      },
    });
  };
// digilocker/callback?code= state
// redux/actions/digilocker.ts
export const getDigilockerCallbackData =
  (code: string, state: string) =>
  async (dispatch: any): Promise<DigilockerCallbackResponse> => {
    return await dispatch({
      [CALL_API]: {
        url: '/onboarding/digilocker/callback',
        method: 'POST',
        types: [GET_DIGILOCKER_CALLBACK_SUCCESS, GET_DIGILOCKER_CALLBACK],
        body: { code, state },
      },
    });
  };

// Storing token from digilocker
export const getInvestorTokenFromLanding = (tokenObj: { token: string }) => ({
  type: REDIRECT_KYC_UPDATE_SUCCESS,
  tokenObj,
});

export const esignKycDocument =
  (referenceId: string) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/esign/kyc-sign/${referenceId}`,
        method: 'POST',
        types: [ESIGN_KYC_DOCUMENT_SUCCESS, ESIGN_KYC_DOCUMENT],
      },
    });
  };

export const updateDigilockerAddress =
  (digilockerId: string, addressUpdateConsent: boolean) =>
  async (dispatch: any): Promise<any> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/digilocker/update-address`,
        method: 'POST',
        types: [UPDATE_DIGILOCKER_ADDRESS_SUCCESS, UPDATE_DIGILOCKER_ADDRESS],
        body: {
          digilockerId,
          addressUpdateConsent,
        },
      },
    });
  };
